<form [formGroup]="businessSignInForm" (ngSubmit)="onClickSignIn()" autocomplete="off">
    <div>
        <div class="form-floating">
            <input class="form-control px-4" type="text" autocomplete="off"
                [placeholder]="'BUSINESS_SIGN_IN.USER_ID_OR_CIVIL_ID'| translate" formControlName="commercialLoginId"
                appBusinessId [maxlength]="businessIdMaxLength" [minlength]="businessIdMinLength" />
            <label class="mandatory">{{ "BUSINESS_SIGN_IN.USER_ID_OR_CIVIL_ID" | translate }}</label>
            <app-validation-message [control]="businessSignInForm.get('commercialLoginId')"></app-validation-message>
        </div>
    </div>
    <button [disabled]="!businessSignInForm.valid" type="submit" class="btn-1 w-100 fw-700 p-2 my-4">
        {{ "BUSINESS_SIGN_IN.LOGIN_BUTTON" | translate }}
    </button>

    <p class="click-here text-2 ibm-medium text-center">
        {{ "SIGN_IN.DONT_HAVE_ACCOUNT" | translate }}
        <span class="c-pointer text-nowrap ibm-medium" (click)="redirectToMOICreatePage()">{{
            "SIGN_IN.CLICK_HERE_TO_SIGN_UP" | translate
            }}</span>
    </p>
</form>
<!-- captcha-->
@if(showCaptcha){
<app-captcha (allowAccess)="handleRecaptchaResponse($event)"></app-captcha>
}